import layoutApi from '@/api/layout'
import templateApi from '@/api/template'
import CONST from '@/config/const/const'
export default {
    namespaced: true,
    state: {
        storedEventInfo:{},
        notiCateCdOptions: [
            // {text: 'Operation', value: '0'},
            {text: 'Nomal', value: '1'},
            {text: 'Deposit', value: '2'},
            {text: 'Withdraw', value: '3'},
            {text: 'Debit Card', value: '4'},
            {text: 'Term Deposit', value: '5'},
            {text: 'Quick Cash', value: '6'},
            {text: 'Quick Credit', value: '7'},
        ],
        notiTypeCdOptions: [
            {text: 'Operation', value: '0'},
            {text: 'Money', value: '1'},
            {text: 'Schedule', value: '2'},
            {text: 'Marketing', value: '3'},
        ],
        layouts: [],
        layoutOptions: [],
        msgTypeOptions:[
            {text: 'Sms', value: CONST.MSG_TYPE.SMS},
            {text: 'Mail', value: CONST.MSG_TYPE.MAIL},
            {text: 'LINE Bank App Push', value: CONST.MSG_TYPE.APP_PUSH},
            {text: 'OA', value: CONST.MSG_TYPE.LINE_OA},
            {text: 'Line 1 to 1', value: CONST.MSG_TYPE.LINE_1TO1},
            {text: 'Notification', value: CONST.MSG_TYPE.NOTIFICATION}
        ],
        queueTypeOptions: [
            {text: 'Regular', value: CONST.QUEUE_TYPE.Regular},
            {text: 'Premium', value: CONST.QUEUE_TYPE.Premium},
        ],
        parameterCountOptions:[
            {text:"0",value:"0"},
            {text:"1",value:"1"},
            {text:"2",value:"2"},
            {text:"3",value:"3"},
            {text:"4",value:"4"},
            {text:"5",value:"5"},
            {text:"6",value:"6"},
            {text:"7",value:"7"},
            {text:"8",value:"8"},
            {text:"9",value:"9"},
            {text:"10",value:"10"},
            {text:"11",value:"11"},
            {text:"12",value:"12"},
            {text:"13",value:"13"},
            {text:"14",value:"14"},
            {text:"15",value:"15"},
            {text:"16",value:"16"},
            {text:"17",value:"17"},
            {text:"18",value:"18"},
            {text:"19",value:"19"},
            {text:"20",value:"20"},
        ],
        parameterSubjectCountOptions:[
            {text:"0",value:"0"},
            {text:"1",value:"1"},
            {text:"2",value:"2"},
            {text:"3",value:"3"},
            {text:"4",value:"4"},
            {text:"5",value:"5"},
            {text:"6",value:"6"},
            {text:"7",value:"7"},
            {text:"8",value:"8"},
            {text:"9",value:"9"},
            {text:"10",value:"10"},
            {text:"11",value:"11"},
            {text:"12",value:"12"},
            {text:"13",value:"13"},
            {text:"14",value:"14"},
            {text:"15",value:"15"},
            {text:"16",value:"16"},
            {text:"17",value:"17"},
            {text:"18",value:"18"},
            {text:"19",value:"19"},
            {text:"20",value:"20"},
        ],
        logStatusTypeOptions: [
            {text: 'ok', value: CONST.LOG_STATUS_TYPE.OK},
            {text: 'fail', value: CONST.LOG_STATUS_TYPE.FAIL},
            {text: 'waiting', value: CONST.LOG_STATUS_TYPE.WAITING},
        ]
    },
    mutations: {
        setLayouts: (state,payload) => {
            state.layouts = payload
        },
        setLayoutOptions: (state,payload) => {
            state.layoutOptions = payload
        },
        setStoredEventInfo: (state,payload) => {
            state.storedEventInfo = payload
        },
    },
    actions: {
        setLayouts({commit},payload) {
            // console.log("mng")
            layoutApi.getLayouts(payload).then(function(result){
                if(!result) return
                let array = result.data.content.content
                commit('setLayouts',array)
                let layoutOptions = array.reduce((base, item, idx, arr) => {
                    base = [...base, {text: item.name, value: item.layoutId, path: item.indexPath}]
                    // base = [...base, {text: item.name, value: item}]  // fix
                    return base
                }, [])
                commit('setLayoutOptions',layoutOptions)
            })
        },
        setStoredEventInfo({commit},payload) {
            commit('setStoredEventInfo',payload)
        },
        callEventInfo({commit},payload) {
            templateApi.getTemplatesInEvents(payload).then((res)=> {
                if(!res) return
                if(res.data.code=== 1000) {
                    commit('setStoredEventInfo',res.data.content)
                } else {
                    this.$notify.error('Fail',res.data.message)
                    commit('setStoredEventInfo',{})
                }
            })
        },
    },
    getters: {
        getLayouts: (state) => (type) => {
            return state.layouts
        },
        getLayoutOptions: (state) => (type) => {
            return state.layoutOptions
        },
        getNotiTypeCdOptions: (state) => (type) => {
            return state.notiTypeCdOptions
        },
        getNotiCateCdOptions: (state) => (type) => {
            return state.notiCateCdOptions
        },
        getMsgTypeOptions: (state) => (type) => {
            return state.msgTypeOptions
        },
        getQueueTypeOptions: (state) => (type) => {
            return state.queueTypeOptions
        },
        getParameterCountOptions: (state) => (type) => {
            return state.parameterCountOptions
        },
        getParameterSubjectCountOptions: (state) => (type) => {
            return state.parameterSubjectCountOptions
        },
        getLogStatusTypeOptions: (state) => (type) => {
            return state.logStatusTypeOptions
        },
        getStoredEventInfo: (state)=> (type) => {
            return state.storedEventInfo
        },
    },
}
